/* eslint-disable import/prefer-default-export */

//export const BASE_URL = 'http://localhost:1337';
//export const BASE_URL = 'http://10.0.103.147:5021';


export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_STRAPPI = process.env.REACT_APP_STRAPI_QA;